import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import MasterGamesList from "../data/MasterGamesList"
import useAppPromotionTheme from "../hooks/useAppPromotionTheme"

export default function CandyRushWheelDrops({ isLightMode }) {
  const isAppPromo = useAppPromotionTheme(isLightMode)
  const navigate = useNavigate()
  const data = promotionsData.find(
    (promo) => promo.title === "Candy Rush Wheel Drops"
  )
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charset="utf-8" />
        <title>Candy Rush Wheel Drops</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion/"
                }
              >
                Promotions
              </a>{" "}
              / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>Candy Rush Wheel Drops</h1>
                <h2>Collect & Win ₱90,000,000</h2>
                <div className="promotion-tnc-period">
                  <strong> Event Period: </strong>
                  <span> June 1 (1:00AM) - June 11, (12:59AM) 2026</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <strong> Mechanics: </strong>
                <ol>
                  <li>
                    70,000 prizes with a prize pool of ₱ 90,886,000 will be
                    given out from 1 June 01:00 to 11 June 2026 00:59 (GMT+8).
                  </li>
                  <li>
                    To qualify for a prize, players must collect all 3 wheel
                    pieces to spin the wheel.
                  </li>
                  <li>
                    Wheel pieces are randomly triggered on any bet with only 1
                    piece awarded at a time. Once the first wheel piece is
                    collected, you will be eligible to collect the next pieces
                    until all three are obtained.
                  </li>
                  <li>
                    Upon completing the wheel, you can tap to spin the wheel and
                    a full-screen vertical wheel will appear to reveal your
                    prize.
                  </li>
                  <li>
                    Prizes are awarded as multipliers and free spins
                    <ul style={{ marginBottom: "0" }}>
                      <li>
                        Multiplier prizes are based of your winning bet stake
                        (multiplier received multiplied by (X) bet stake, and
                        the bet stake is capped at ₱58 for prize payout)
                      </li>
                      <li>
                        Free Spins are awarded in Candy Rush, at the same bet
                        stake used to win the prize. If the bet stake exceeds
                        the ₱58 value, the Free Spins will be awarded at the ₱58
                        value.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Players can choose to play free spins instantly or later.
                    Free spins will be valid for 3 days from the time of
                    awarding, after which they will expire.
                  </li>
                  <li>
                    All winnings are credited as cash without any wagering
                    requirements.
                  </li>
                  <li>
                    You can track your progress on collecting the wheel pieces
                    in real time within the promotional interface.
                  </li>
                  <li>
                    Each player may win a maximum of 2 prizes during this
                    promotion.
                  </li>
                  <li>No minimum bet is required for this promotion.</li>
                  <li>
                    Pragmatic Play reserves the right to thoroughly review
                    players activities to identify any potential abuse to ensure
                    fair play within our Network Promotion. If any abuse is
                    found, Pragmatic Play reserves the right to forfeit any
                    amounts paid to winning players.
                  </li>
                  <li>
                    Pragmatic Play reserves the right to amend, suspend or
                    cancel the promotion at any time and without prior notice.
                  </li>
                </ol>
                {!isAppPromo && <strong>Qualified Game: </strong>}
                {!isAppPromo && (
                  <MasterGamesList
                    qualifiedGamesOnly="on"
                    customWrapperClass="gameListWrapper promotion-signup-game-list"
                    customQualifiedGames={[
                      {
                        provider: "pp",
                        gameName: "Candy Rush",
                      },
                    ]}
                    rank="off"
                    limit={2}
                    headerText={null}
                    linkTo={null}
                    headerTag="h2"
                  />
                )}
                <div className="table-wrapper">
                  <table
                    className="promotion-tnc-table"
                    style={{ minWidth: "0" }}
                  >
                    <thead>
                      <tr>
                        <th>Number of Prizes</th>
                        <th>Prizes</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>x100,000 Multiplier</td>
                      </tr>

                      <tr>
                        <td>9</td>
                        <td>x3,000 Multiplier</td>
                      </tr>

                      <tr>
                        <td>40</td>
                        <td>x1,000 Multiplier</td>
                      </tr>

                      <tr>
                        <td>450</td>
                        <td>x500 Multiplier</td>
                      </tr>

                      <tr>
                        <td>1,000</td>
                        <td>x100 Multiplier</td>
                      </tr>

                      <tr>
                        <td>3,500</td>
                        <td>x50 Multiplier</td>
                      </tr>

                      <tr>
                        <td>25,000</td>
                        <td>20 Free Spins</td>
                      </tr>

                      <tr>
                        <td>40,000</td>
                        <td>10 Free Spins</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="promotion-tnc-cta">
                  <a
                    className="promotion-cta-btn"
                    href="https://pp88.asia/tl/candy-rush-wheel-drops"
                    target="_blank"
                    rel="noreferrer"
                  >
                    View Full T&C
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
